var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_core.js
// module id = 85
// module chunks = 1